import { z } from "@hono/zod-openapi";
import { UNCATEGORIZED_CATEGORY, tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * A form the vocabulary does not name, labeled by the vendor's own title.
 */
export const otherV1 = tmsEventKind(
  { category: UNCATEGORIZED_CATEGORY, kind: "other", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      /** The vendor's title, which the chip shows where a mapped kind would show its kind name. */
      label: z.string(),
    },
  },
);

export const OtherV1Schema = otherV1.schema;
export const OtherV1FactsSchema = otherV1.facts;

export type OtherV1 = z.infer<typeof OtherV1Schema>;
export type OtherV1Facts = z.infer<typeof OtherV1FactsSchema>;

/** Every version of `other`, keyed by version. What `catalog.ts` places under `uncategorized`. */
export const other = { 1: otherV1 } as const;
